'use client';
import { jsxs as x, jsx as l } from "react/jsx-runtime";
import { Icon as O } from "@tameeni/icons";
import { cn as _ } from "@tameeni/shared-logic";
import P, { useState as g } from "react";
import B, { components as v } from "react-select";
import { Button as H } from "../button/button.js";
import { getClassNames as L } from "./components.js";
import Y from "./floating-placeholder.js";
const w = (n) => {
  const i = (e) => {
    const s = e.currentTarget, { scrollTop: r, scrollHeight: a, clientHeight: o } = s, c = r === 0, u = r + o === a;
    e.deltaY < 0 && c || e.deltaY > 0 && u || e.stopPropagation();
  };
  return /* @__PURE__ */ l(
    v.Menu,
    {
      ...n,
      innerProps: {
        ...n.innerProps,
        onWheel: i
      }
    }
  );
}, F = (n) => {
  const i = (e) => {
    const s = e.currentTarget, { scrollTop: r, scrollHeight: a, clientHeight: o } = s, c = r === 0, u = Math.abs(r + o - a) < 1;
    e.deltaY < 0 && c || e.deltaY > 0 && u || e.stopPropagation();
  };
  return /* @__PURE__ */ l(
    v.MenuList,
    {
      ...n,
      innerProps: {
        ...n.innerProps,
        onWheel: i
      }
    }
  );
}, R = P.forwardRef(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (n, i) => {
    const {
      value: e,
      options: s,
      className: r,
      onChange: a,
      onClear: o,
      placeholder: c,
      isInvalid: u = !1,
      isDisabled: I,
      isLoading: y,
      isSearchable: j,
      menuClassName: k,
      maxOptionsToShow: z,
      onMenuScrollToBottom: W,
      // Extract our custom props
      ...p
      // All remaining props will be passed to ReactSelect
    } = n, [S, h] = g(!!e), [T, M] = g(!1), [C, D] = g(!1), m = P.useMemo(() => s.find((t) => String(t.value) === String(e)), [e, s]), N = (t) => {
      const {
        getStyles: d,
        innerProps: { ref: f, ...b }
      } = t;
      return /* @__PURE__ */ l(
        "div",
        {
          ...b,
          ref: f,
          style: d("clearIndicator", t),
          children: /* @__PURE__ */ l(
            H,
            {
              variant: "text",
              colorPalette: "slate",
              "aria-label": "Clear",
              size: "loose",
              onClick: o,
              ...t,
              children: /* @__PURE__ */ l(O, { name: "Close" })
            }
          )
        }
      );
    };
    return /* @__PURE__ */ x("div", { className: _("relative", r), children: [
      /* @__PURE__ */ l(
        B,
        {
          options: s,
          unstyled: !0,
          ref: i,
          value: m,
          noOptionsMessage: () => "No options",
          onMenuOpen: () => M(!0),
          onMenuClose: () => M(!1),
          components: {
            ClearIndicator: N,
            Menu: w,
            MenuList: F,
            ...p.components
          },
          onChange: (t, d) => {
            if (d.action === "clear")
              o == null || o(), h(!1);
            else if (t) {
              const f = t.value;
              a == null || a(String(f)), h(!0);
            }
          },
          classNames: L({
            isInvalid: u,
            isMenuOpened: T || C,
            isSelected: S
          }),
          isDisabled: I,
          isLoading: y,
          isSearchable: !0,
          menuPortalTarget: typeof window < "u" ? document.body : void 0,
          styles: {
            ...p.styles,
            menuPortal: (t, d) => ({
              ...t,
              pointerEvents: "auto",
              zIndex: 9999
            })
          },
          ...p
        },
        `react_select_key_${m == null ? void 0 : m.value}`
      ),
      /* @__PURE__ */ l(Y, { isSelected: S, children: c })
    ] });
  }
);
R.displayName = "SingleSelect";
export {
  R as SingleSelect
};
